import * as React from "react";
import { useRouter } from "next/navigation";
import { useTranslation } from "react-i18next";
import {
  FaCreditCard,
  FaEnvelope,
  FaHistory,
  FaKey,
  FaLock,
  FaSignOutAlt,
  FaTrash,
  FaUser,
} from "react-icons/fa";
import { Header, MenuListProps } from "../organisms/header";
import { useUserQuery } from "../../graphql/query";
import { useLogout } from "../../utils/auth-hooks";
import { Footer } from "@graffer-inc/graffer-design-kit";
import { footerLinkInfos } from "../../consts/fotter-link";

const NavbarSpacer = () => <div style={{ height: "52px" }} />;

type Props = {
  title?: string;
  children: React.ReactNode;
};

export const AuthLayout: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { data } = useUserQuery();
  const [logout] = useLogout();

  const googleAcount = data?.user?.googleId;
  const lineAcount = data?.user?.lineId;

  const menuItems = [
    {
      name: t(`%%%サービス一覧%%%`),
      icon: <FaCreditCard />,
      onClick: () => router.push(`/services`),
    },
    {
      name: t(`%%%基本情報設定・変更%%%`),
      icon: <FaUser />,
      onClick: () => router.push(`/setting/profile`),
      hasDividerBefore: true,
    },
    !googleAcount && {
      name: t(`%%%メールアドレス変更%%%`),
      icon: <FaEnvelope />,
      onClick: () => router.push("/setting/mail"),
    },
    !googleAcount &&
      !lineAcount && {
        name: t(`%%%パスワード変更%%%`),
        icon: <FaKey />,
        onClick: () => router.push(`/setting/password`),
      },
    {
      name: t(`%%%二段階認証設定・変更%%%`),
      icon: <FaLock />,
      onClick: () => router.push("/setting/two-phase-auth"),
    },
    {
      name: t(`%%%ログイン履歴%%%`),
      icon: <FaHistory />,
      onClick: () => router.push("/login-activities"),
      hasDividerBefore: true,
    },
    {
      name: t(`%%%アカウントの退会%%%`),
      icon: <FaTrash />,
      onClick: () => router.push("/delete-account"),
    },
    {
      name: t(`%%%ログアウト%%%`),
      icon: <FaSignOutAlt />,
      onClick: logout,
      hasDividerBefore: true,
    },
  ].filter((s) => !!s) as Array<MenuListProps>;

  // if menuItems inclueds false, it's removed
  menuItems.forEach((element, index) => {
    if (!element) {
      menuItems.splice(index, 1);
    }
  });

  return (
    <div>
      <Header
        fixed={true}
        serviceName={t(`%%%アカウント%%%`)}
        menuLabel={
          data?.user?.firstName && data.user.lastName
            ? t(`%%% {{lastName}} {{firstName}}%%%`, data.user)
            : t(`%%%未設定%%%`)
        }
        menuItems={menuItems}
        menuIcon={null}
        menuDividerPositions={getMenuItemsDividerPosition(menuItems)}
        onClickLogo={() => {
          router.push("/");
        }}
      />
      {/* NavBar fixed */}
      <NavbarSpacer />
      <main className="c-content-wrapper">{props.children}</main>
      <Footer
        companyLabel="株式会社グラファーが運営しています。"
        linkInfos={footerLinkInfos}
      />
    </div>
  );
};

function getMenuItemsDividerPosition(menuItems: any) {
  const menuItemsCount: any = [];
  menuItems.forEach((m: any, index: any) => {
    if (m.hasDividerBefore) {
      menuItemsCount.push(index);
    }
  });
  return menuItemsCount;
}
